module.exports = __webpack_public_path__ + "media/appointment/appointment-36d8c915.png";